import { useEffect } from "react"
import { dropTargetForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter"
import type { DragData } from "./dragData"
import { dropZone } from "./dropZone"

/** The page around a canvas, where something placed on it is let go of to come off. */
export const offCanvas = dropZone("off the canvas")

/**
 * Registers the page as off the canvas for the drags `accepts` takes, so
 * letting go of one anywhere off the canvas is a drop there, not the drop on
 * nothing Escape makes. The canvas must take the same drags, or letting go
 * between its cards would fall through to the page.
 */
export function useOffCanvas(accepts: (source: DragData) => boolean) {
  useEffect(
    () =>
      dropTargetForElements({
        element: document.body,
        canDrop: ({ source }) => accepts(source.data),
        getData: () => offCanvas.data(),
      }),
    [accepts],
  )
}
